import './index.scss'
import text from './text.json'
import {useDispatch, useSelector} from 'react-redux'
import {setConfirmIsActive} from '../../../stores/alert'
import {CloseIcon} from '../../../icons'
import {SimpleBlueButton} from '../button'
import ButtonLoader from '../button/ButtonLoader'
import classNames from 'classnames'

const Confirm = ({body, callback, showLoader}) => {
    const isActive = useSelector(state => state.alert.confirmIsActive)
    const dispatch = useDispatch()
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const stopPropagation = e => {
        e.stopPropagation()
    }
    const closeConfirm = () => {
        dispatch(setConfirmIsActive(false))
    }
    return (
        <div className={`confirm ${isActive ? 'active' : ''}`} onClick={closeConfirm}>
            <div className={classNames('confirm-content', {
                dark: isDarkMode
            })} onClick={stopPropagation}>
                <div className="confirm-header">
                    <h5>{text.are_you_sure}</h5>
                    <span className="close d-flex" onClick={closeConfirm}>
                        <CloseIcon/>
                    </span>
                </div>
                <div className="confirm-body" onClick={stopPropagation}>
                    {body}
                </div>
                <div className="buttons">
                    <button className="cancel-button" onClick={closeConfirm}>{text.decline}</button>
                    <SimpleBlueButton onClick={callback} disabled={showLoader}>
                        {showLoader && <ButtonLoader/>}
                        {text.accept}
                    </SimpleBlueButton>
                </div>
            </div>
        </div>
    )
}

export default Confirm
